/* mif edit 2026-10-07: keep the header cart count in sync when an app (Flash Cart) changes the cart.
   Watches /cart/add|change|update|clear requests, then reads /cart.js and updates .m-cart-count-bubble. */
(function () {
  if (window.__mifCartCount) return;
  window.__mifCartCount = true;

  var CHANGE_RE = /\/cart\/(add|change|update|clear)(\.js|\.json)?(\?|#|$)/;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var timer;

  function render(count) {
    document.querySelectorAll('.m-cart-count-bubble').forEach(function (el) {
      if (count > 0) {
        el.textContent = count;
        el.classList.remove('m:hidden');
      } else {
        el.classList.add('m:hidden');
      }
    });
    document.querySelectorAll('.m-cart-icon-bubble').forEach(function (el) {
      el.setAttribute('aria-label', count);
    });
  }

  function refresh() {
    clearTimeout(timer);
    timer = setTimeout(function () {
      fetch(root + 'cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
        .then(function (r) { return r.json(); })
        .then(function (cart) { render(cart.item_count); })
        .catch(function () {});
    }, 150);
  }

  if (window.PerformanceObserver) {
    try {
      new PerformanceObserver(function (list) {
        list.getEntries().forEach(function (e) {
          if (CHANGE_RE.test(e.name)) refresh();
        });
      }).observe({ type: 'resource', buffered: false });
    } catch (err) {}
  }

  document.addEventListener('cart:updated', refresh);
})();
